var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.91013 3.48513C4.64448 3.71901 1.8551 5.79788 1.8551 5.79788C1.74884 5.87584 1.64258 6.08373 1.64258 6.21366C1.64258 6.21366 1.64258 8.13662 1.64258 8.96817C1.64258 9.82571 2.81146 9.77374 2.81146 8.94219C2.81146 8.13662 2.81146 6.94127 2.81146 6.94127C2.81146 6.81134 2.91772 6.60345 3.02398 6.52549L4.51165 5.38211C4.61791 5.30415 4.72417 5.33014 4.72417 5.48605V8.96817C4.72417 9.12409 4.80387 9.30599 4.9367 9.38395L8.25738 12.0085C8.36364 12.0865 8.49647 12.2684 8.5496 12.4243C8.5496 12.4243 9.45283 14.919 9.82474 16.0104C10.1967 17.1018 11.6578 16.66 11.3124 15.5426C11.0999 14.893 9.87787 11.5148 9.87787 11.5148C9.82474 11.3849 9.69191 11.203 9.58565 11.099L6.95567 8.96817C6.95567 8.96817 6.95567 5.14823 6.95567 4.60253C6.98224 4.08281 5.20235 3.25126 4.91013 3.48513Z",
    fill: "#5C5F62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.57755 10.3889C4.57755 10.3889 1.87805 14.7939 1.14421 15.902C0.436577 17.0102 1.82564 17.8967 2.45464 16.8994C3.08365 15.9297 5.80935 11.3863 5.80935 11.3863L4.57755 10.3889Z",
    fill: "#5C5F62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.19824 8.34853C7.19824 8.34853 8.1821 9.02802 8.87659 9.53763C9.57109 10.0472 10.4103 9.19789 9.71577 8.664C9.02128 8.13012 7.19824 6.91675 7.19824 6.91675V8.34853H7.19824Z",
    fill: "#5C5F62"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.11523 1.62829C5.11523 2.88363 6.36134 3.44453 6.93247 3.44453C7.34784 3.44453 7.89301 3.39111 7.89301 2.29602C7.89301 1.20094 7.60745 0.666748 6.36134 0.666748C5.97193 0.666748 5.11523 0.773586 5.11523 1.62829Z",
    fill: "#5C5F62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalking);
export default __webpack_public_path__ + "static/media/walking.71f3c81e0c0a4c3f3696a1279cea4aca.svg";
export { ForwardRef as ReactComponent };